import { render, staticRenderFns } from "./inTranStockList.vue?vue&type=template&id=cfab65b8"
import script from "./inTranStockList.vue?vue&type=script&lang=js"
export * from "./inTranStockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports